export enum ModelTypes {
  GPT_4O = "gpt-4o",
  GPT_4O_MINI = "gpt-4o-mini",
  O3_MINI = "o3-mini",
  O3_MINI_HIGH = "o3-mini-high",
  GPT_4O_NO_CACHE = "gpt-4o-no-cache",
}

export abstract class Model {
  abstract readonly modelType: ModelTypes;
  abstract readonly speedRating: number;
  abstract readonly qualityRating: number;
}

export namespace QuestionGenerationModels {
  const registry: { new (): Model }[] = [];

  export function Register<T extends { new (...args: unknown[]): Model }>(
    ctor: T,
  ) {
    registry.push(ctor);
  }

  export function getAll(): Model[] {
    return registry.map((ctor) => new ctor());
  }
}

export namespace ChatModels {
  const registry: { new (): Model }[] = [];

  export function Register<T extends { new (...args: unknown[]): Model }>(
    ctor: T,
  ) {
    registry.push(ctor);
  }

  export function getAll(): Model[] {
    return registry.map((ctor) => new ctor());
  }
}

@QuestionGenerationModels.Register
@ChatModels.Register
export class GPT4o extends Model {
  readonly modelType = ModelTypes.GPT_4O;
  readonly qualityRating = 8;
  readonly speedRating = 8;
}

@QuestionGenerationModels.Register
@ChatModels.Register
export class GPT4oMini extends Model {
  readonly modelType = ModelTypes.GPT_4O_MINI;
  readonly qualityRating = 4;
  readonly speedRating = 10;
}

@QuestionGenerationModels.Register
export class O3Mini extends Model {
  readonly modelType = ModelTypes.O3_MINI;
  readonly qualityRating = 9;
  readonly speedRating = 5;
}

@QuestionGenerationModels.Register
export class O3MiniHigh extends Model {
  readonly modelType = ModelTypes.O3_MINI_HIGH;
  readonly qualityRating = 10;
  readonly speedRating = 3;
}
